import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { convertObjectToQueryParams } from 'src/utils/util';
import axios from 'src/api/Api';

import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
    SET_PRODUCT_TEMPLATE_REFINE_DATA,
    UPDATE_PRODUCT_TEMPLATE_SUCCESS,
    UPDATE_PRODUCT_TEMPLATE_FAILURE,
    CREATE_PRODUCT_TEMPLATE_SUCCESS,
    CREATE_PRODUCT_TEMPLATE_FAILURE,
    SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
    GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
    GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
    VALIDATE_PRODUCTS,
} from '../actions/actionTypes';
import {
    getDataForEquityTemplateDataService,
    getDetailedEquityProductTemplatesDataService,
    getEquityTemplateDetailsDataService,
    updateEquityProductTemplateDataService,
} from '../../services';
import {
    getDetailedEquityProductTemplatesEndpoint,
    getEquityTemplateDetailsEndpoint,
    updateEquityProductTemplateEndpoint,
    getDataForEquityTemplateEndpoint,
} from '../../services/endpoints';
import { getDropdownValues } from '../actions';

export function* getDetailedEquityProductTemplates(action) {
    const resourceType = 'ORDER_TEMPLATE_B';
    const queryParams = convertObjectToQueryParams({
        ...action.payload,
        resourceType: resourceType,
        templateType: action.payload.orderType,
    });

    try {
        const result = yield getDetailedEquityProductTemplatesDataService(
            queryParams
        );
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
            payload: result.templateList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            pagination: {
                pageNum: result.pageNo,
                pageLimit: result.pageSize,
            },
            totalNoOfResults: result.totalNoOfResults,
        });
        yield put({
            type: SET_PRODUCT_TEMPLATE_REFINE_DATA,
            payload: result.templateRefineData || {},
        });
        yield put({
            type: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
            payload: result.templateSubCategoryList || [],
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getDetailedEquityProductTemplatesEndpoint(queryParams),
            requestPayload: action.payload
        });
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* getEquityTemplateDetails(action) {
    try {
        const result = yield getEquityTemplateDetailsDataService(
            action.payload
        );
        yield put({
            type: VALIDATE_PRODUCTS,
            payload: {
                products:
                    result?.setProducts?.length > 0 &&
                    result?.itemProducts?.length > 0
                        ? [...result?.setProducts, ...result?.itemProducts]
                        : result?.setProducts?.length > 0
                        ? [...result.setProducts]
                        : (result.itemProducts.length > 0 && [
                              ...result.itemProducts,
                          ]) ||
                          [],
                orderType: 'ZOR',
                templateScreen: true,
            },
        });
        yield put({
            type: GET_TEMPLATE_DETAILS_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getEquityTemplateDetailsEndpoint(action.payload),
            requestPayload: action.payload
        });
        yield put({
            type: GET_TEMPLATE_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* createEquityProductTemplate(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;
    let result;
    let insideCatch = false;
    let responseData;
    try {
        result = yield axios
            .post(url, { ...action.payload })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    // Request made and server responded
                    insideCatch = true;
                    responseData = error.response.data;
                    logUiErrorToBackend('error response', error.response);
                } else if (error.request) {
                    // The request was made but no response was received
                    logUiErrorToBackend('error request', error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    logUiErrorToBackend('Error', error.message);
                }
            });
        // yield createEquityProductTemplateDataService({...action.payload});
        if (insideCatch) {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_FAILURE,
                statusCode: responseData.statusCode,
                statusMessage: responseData.statusDescription,
            });
            insideCatch = false;
        } else {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_SUCCESS,
                payload: result || {},
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: CREATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: '422',
            statusMessage: errorHandler('422'),
        });
    }
}

export function* updateEquityProductTemplate(action) {
    try {
        const result = yield updateEquityProductTemplateDataService({
            ...action.payload,
        });
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: updateEquityProductTemplateEndpoint,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

function mapOrderHistorySummaryToEquityTemplateData(summaryData) {
    const orderBasicDetails = summaryData?.orderBasicDetails || {};
    const orderSummaryDetail = orderBasicDetails.orderSummaryDetail || {};
    const procedureDetail = orderBasicDetails.procedureDetail || {};
    const orderDetails = (summaryData?.orderDetails || []).filter((product) => {
        const approval = (product?.approval || '').toString().toUpperCase();
        return (
            product &&
            !product.isBundleHeader &&
            (product?.cfn || '').toString().trim().length > 0 &&
            approval !== 'UNAPPROVED' &&
            !product.isExcluded &&
            !product.isExclude &&
            !product.isExcludedItem &&
            !product.isExclusionItem &&
            !product.isExcludedExtraItem &&
            !product.isInvalidItemMsg &&
            !product.reservationSetErrorMessage
        );
    });

    const accountCode =
        orderBasicDetails.accountNumber ||
        orderSummaryDetail.accountCode ||
        orderBasicDetails.accountId ||
        '';
    const accountName = orderBasicDetails.accountName || orderSummaryDetail.accountName || '';
    const physicianId = orderSummaryDetail.physicianId || '';
    const physicianName = orderSummaryDetail.physicianName || '';
    const territoryDetails = orderSummaryDetail.derivedTerritoryDetails?.[0] || {};
    const districtCode =
        orderSummaryDetail.districtUID ||
        orderBasicDetails.districtUID ||
        orderSummaryDetail.districtCode ||
        '';
    const territoryCode =
        orderSummaryDetail.territoryUID ||
        orderSummaryDetail.territoryCode ||
        territoryDetails.territory ||
        '';
    const procedureCode = procedureDetail.procedureCode || '';

    const feeProducts = orderDetails.filter(
        (p) => p?.materialType === 'DIEN'
    );
    const itemProducts = orderDetails.filter(
        (p) => !p.isSet && p?.materialType !== 'DIEN'
    );

    return {
        accountsSelected: accountCode
            ? [{ accountId: accountCode, accountName }]
            : [],
        physiciansSelected: physicianId
            ? [{ physicianId, name: physicianName }]
            : [],
        procedureSelected: procedureCode,
        districtUID: districtCode,
        territoryUID: territoryCode,
        feeProducts,
        itemProducts,
        setProductsCount: feeProducts.length,
        itemProductsCount: itemProducts.reduce(
            (sum, p) => sum + (parseInt(p.quantity, 10) || 0),
            0
        ),
        templateType: 'equity',
    };
}

const hasUsableEquityTemplateData = (templateData = {}) =>
    !!(
        templateData?.accountsSelected?.length &&
        templateData?.districtUID &&
        templateData?.territoryUID &&
        (templateData?.itemProducts?.length ||
            templateData?.feeProducts?.length ||
            templateData?.setProducts?.length)
    );

export function* getDataForEquityTemplate(action) {
    const isFromOrderHistory = action.payload.isFromOrderHistory || false;
    const summaryParams = convertObjectToQueryParams({
        myCaseRef: action.payload.MyCASERef,
        resourceType: 'ALL',
    });
    const orderHistoryUrl = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/orderHistorySummary?${summaryParams}`;
    const orderSummaryUrl = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/summary?${summaryParams}`;
    try {
        let result;
        if (isFromOrderHistory) {
            result = yield axios.get(orderHistoryUrl).then((response) => response.data);
            result = mapOrderHistorySummaryToEquityTemplateData(result);
        } else {
            result = yield getDataForEquityTemplateDataService(
                action.payload.MyCASERef,
                action.payload.orderType
            );
            if (action.payload.MyCASERef && !hasUsableEquityTemplateData(result)) {
                const summaryResult = yield axios.get(orderSummaryUrl).then((response) => response.data);
                result = mapOrderHistorySummaryToEquityTemplateData(summaryResult);
            }
        }
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
        yield getDropdownValues({
            dropDownName: 'territories',
            value: result && result.districtUID,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: isFromOrderHistory
                ? orderHistoryUrl
                : getDataForEquityTemplateEndpoint(action.payload.MyCASERef, action.payload.orderType),
            requestPayload: action.payload
        });
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
